module.exports = __webpack_public_path__ + "img/cardiovascular.341dbde0.png";